import { action, makeObservable, observable } from 'mobx';
import { CustomerCSVConfigurationService } from 'services/data-services/CustomerCSVConfigurationService';

export class CustomerCSVConfigurationStore {
  private customerCSVConfigurationService: CustomerCSVConfigurationService;

  @observable defaultColumns: string[] = [];

  constructor(customerCSVConfigurationService: CustomerCSVConfigurationService) {
    this.customerCSVConfigurationService = customerCSVConfigurationService;
    makeObservable(this);
  }

  @action getConfiguration = async () => {
    this.defaultColumns = await this.customerCSVConfigurationService.fetchConfiguration();
  };
}
